import {AxiosResponse} from "axios";
import React from "react";
import {RouteComponentProps, withRouter} from "react-router";
import Form from "../../../../common/components/shared/form/form";
import {HttpErrorModel} from "../../../../common/models/httpError";
import {storesContext} from "../../../../common/stores/stores";
import {Api} from "../../../../helpers/api";
import {routingAddresses} from "../../../../helpers/routing";
import {Utils} from "../../../../helpers/utils";
import i18n from "../../../../i18n/i18n";
import {observer} from "mobx-react";
import GeneralInformationSection from "./generalInformationSection/generalInformationSection";
import "../../transportation.scss";
import TemperatureSection from "./temperatureSection/temperatureSection";
import TransportationSection from "./transportationSection/transportationSection";
import VoyageSection from "./voyageSection/voyageSection";
import CargoSection from "./cargoSection/cargoSection";
import ContainerSection from "./containerSection/containerSection";
import CostsSection from "./costsSection/costsSection";
import DangerousGoodsSection from "../../dangerousGoodsSection/dangerousGoodsSection";
import {IOrderStore} from "../../../stores/orderStore";
import {NewOrUpdateOrderModel} from "../../../models/order";
import {DateUtils} from "../../../../helpers/dateUtils";
import {OrderService} from "../../../services/orderService";
import {HttpError} from "../../../../common/components/shared/httpError/httpError";
import TransportUtils from "../../../../helpers/transportUtils";

interface OrderFormState {
    submitButtonWasClicked: boolean;
    isSubmitButtonBlocked: boolean;
    response: AxiosResponse<HttpErrorModel[] | any> | undefined;
}

interface OrderFormProps extends RouteComponentProps {
    isUpdate: boolean;
    id?: string;
}

class OrderForm extends React.Component <OrderFormProps, OrderFormState> {
    static contextType = storesContext;

    constructor(props: any) {
        super(props);

        this.state = {
            submitButtonWasClicked: false,
            isSubmitButtonBlocked: false,
            response: undefined
        };
    }

    componentWillUnmount() {
        this.context.orderStore.clearStore();
    }

    render(): JSX.Element {
        return (
            <Form
                class="transportation-order-form"
                renderContent={this.renderContent()}
                renderError={this.renderErrors()}
                submit={this.submit.bind(this)}
                backAddress={routingAddresses.order.list}
                isSubmitButtonBlocked={this.state.isSubmitButtonBlocked}
                saveButtonText={this.props.isUpdate ? i18n.t("save") : i18n.t("transportation.order.addOrder.saveButtonText")}
            />
        );
    }

    private renderErrors() {
        if (!Api.isSuccess(this.state.response)) {
            return (
                <HttpError
                    response={this.state.response}
                    cause={this.getErrorMessage()}
                    translatedFields={{
                        pinCode: i18n.t("transportation.order.addOrder.httpErrors.pinCode"),
                        barcodeNo: i18n.t("transportation.order.addOrder.httpErrors.barcodeNo"),
                        voyageNo: i18n.t("transportation.order.addOrder.httpErrors.voyageNo"),
                        bookingNo: i18n.t("transportation.order.addOrder.httpErrors.bookingNo"),
                    }}
                    translatedFieldsForEmpty={{
                        statusEmpty: i18n.t("transportation.order.details.general.properties.status"),
                        relationTypeEmpty: i18n.t("transportation.order.details.general.properties.relationType"),
                        cargoTypeEmpty: i18n.t("transportation.order.details.general.properties.cargoType"),
                        pinCodeEmpty: i18n.t("transportation.order.details.general.properties.pinCode"),
                        barcodeNoEmpty: i18n.t("transportation.order.details.general.properties.barcodeNo"),
                        requestedTemp1Empty: i18n.t("transportation.order.details.temperature.properties.requestedTemp1"),
                        requestedTemp2Empty: i18n.t("transportation.order.details.temperature.properties.requestedTemp2"),
                        trailerRegNoEmpty: i18n.t("transportation.order.details.transportation.properties.trailerRegNo"),
                        transportCompanyEmpty: i18n.t("transportation.order.details.transportation.properties.transportCompany"),
                        recipientEmpty: i18n.t("transportation.order.details.transportation.properties.recipient"),
                        lorryRegNoEmpty: i18n.t("transportation.order.details.transportation.properties.lorryRegNo"),
                        supplierLorryRegNoEmpty: i18n.t("transportation.order.details.transportation.properties.supplierLorryRegNo"),
                        recipientLorryRegNoEmpty: i18n.t("transportation.order.details.transportation.properties.recipientLorryRegNo"),
                        shipownerNameEmpty: i18n.t("transportation.order.details.voyage.properties.shipownerName"),
                        voyageNoEmpty: i18n.t("transportation.order.details.voyage.properties.voyageNo"),
                        arrivalDepartureTimeEmpty: i18n.t("transportation.order.details.voyage.properties.arrivalDepartureTime"),
                        ferryNameEmpty: i18n.t("transportation.order.details.voyage.properties.ferryName"),
                        originDestinationPortEmpty: i18n.t("transportation.order.details.voyage.properties.originDestinationPort"),
                        originDestinationCountryEmpty: i18n.t("transportation.order.details.voyage.properties.originDestinationCountry"),
                        bookingNoEmpty: i18n.t("transportation.order.details.voyage.properties.bookingNo"),
                        cargoDescEmpty: i18n.t("transportation.order.details.cargo.properties.cargoDesc"),
                        weightEmpty: i18n.t("transportation.order.details.cargo.properties.weight"),
                        lengthEmpty: i18n.t("transportation.order.details.cargo.properties.length"),
                        heightEmpty: i18n.t("transportation.order.details.cargo.properties.height"),
                        widthEmpty: i18n.t("transportation.order.details.cargo.properties.width"),
                        packingQuantityEmpty: i18n.t("transportation.order.details.cargo.properties.packingQuantity"),
                        cbmEmpty: i18n.t("transportation.order.details.cargo.properties.cbm"),
                        packingEmpty: i18n.t("transportation.order.details.cargo.properties.packing"),
                        remarksEmpty: i18n.t("transportation.order.details.cargo.properties.remarks"),
                        wagonRegNoEmpty: i18n.t("transportation.order.details.cargo.properties.wagonRegNo"),
                        supplierWagonRegNoEmpty: i18n.t("transportation.order.details.cargo.properties.supplierWagonRegNo"),
                        recipientWagonRegNoEmpty: i18n.t("transportation.order.details.cargo.properties.recipientWagonRegNo"),
                        securingDeclarationEmpty: i18n.t("transportation.order.details.cargo.properties.securingDeclaration"),
                        containerNoEmpty: i18n.t("transportation.order.details.container.properties.containerNo"),
                        containerSizeEmpty: i18n.t("transportation.order.details.container.properties.containerSize"),
                        vgmEmpty: i18n.t("transportation.order.details.container.properties.vgm"),
                        paymentDocumentNumberEmpty: i18n.t("transportation.order.details.costs.properties.paymentDocumentNumber"),
                        unCodeEmpty: i18n.t("transportation.order.details.dangerousGoods.properties.unCode")
                    }}
                    object={i18n.t("transportation.order.addOrder.httpErrors.object")}
                />
            );
        }
    }

    private getErrorMessage() {
        return this.props.isUpdate ? i18n.t("transportation.order.modifyOrder.errors.modifyErrorSuffix") : i18n.t("transportation.order.addOrder.errors.addErrorSuffix");
    }

    private renderContent(): JSX.Element {
        const orderStore = this.context.orderStore as IOrderStore;

        return (
            <>
                <GeneralInformationSection validForm={this.state.submitButtonWasClicked} isUpdate={this.props.isUpdate} orderId={this.props.id}/>
                <TemperatureSection/>
                <TransportationSection/>
                {orderStore.displayVoyageSection && <VoyageSection/>}
                <CargoSection/>
                {orderStore.displayContainerProperties && <ContainerSection/>}
                {orderStore.displayCostsSection && <CostsSection isUpdate={this.props.isUpdate}/>}
                <DangerousGoodsSection store={this.context.orderStore as IOrderStore}/>
            </>
        );
    }

    private get isValid(): boolean {
        const orderStore = this.context.orderStore as IOrderStore;
        return orderStore.orderIsValid();
    }

    private async submit(): Promise<void> {
        this.setState({submitButtonWasClicked: true, response: undefined});

        if (this.isValid) {
            this.setState({isSubmitButtonBlocked: true});

            let response: AxiosResponse<HttpErrorModel[] | any>;

            if (this.props.isUpdate && this.props.id) {
                response = await OrderService.modifyOrder(this.prepareDataToApiForModifyOrder(), this.props.id);
            } else {
                response = await OrderService.addOrder(this.prepareDataToApiForNewOrder());
            }

            this.setState({isSubmitButtonBlocked: false, response});

            if (Api.isSuccess(this.state.response)) {
                this.props.history.push(routingAddresses.order.list);
            }
        }

        Utils.scrollToFirstErrorMessage();
    }

    private prepareDataToApiForNewOrder(): NewOrUpdateOrderModel {
        const orderStore = this.context.orderStore as IOrderStore;

        return {
            arrivalDepartureTime: DateUtils.getFormattedDateWithTimeInUTC(orderStore.arrivalDepartureTime.value),
            barcodeNo: orderStore.barcodeNo.value?.trim() || undefined,
            bookingNo: orderStore.bookingNo.value?.trim() || undefined,
            cargoDesc: orderStore.cargoDesc.value || undefined,
            cargoType: orderStore.cargoType.value,
            CBM: orderStore.cbm.value ? Number(Utils.changeCommaToDot(orderStore.cbm.value)) : undefined,
            containerNo: orderStore.containerNo.value || undefined,
            containerSize: orderStore.containerSize.value || undefined,
            dangerousGoods: TransportUtils.prepareDangerousGoods(orderStore.dangerousGoods),
            ferryId: orderStore.ferryId.value || undefined,
            height: orderStore.height.value ? Number(Utils.changeCommaToDot(orderStore.height.value)) : undefined,
            length: orderStore.length.value ? Number(Utils.changeCommaToDot(orderStore.length.value)) : undefined,
            lorryRegNo: orderStore.lorryRegNo.value || undefined,
            supplierLorryRegNo: orderStore.supplierLorryRegNo.value || undefined,
            recipientLorryRegNo: orderStore.recipientLorryRegNo.value || undefined,
            originDestinationCountry: orderStore.originDestinationCountry.value || undefined,
            originDestinationPortId: orderStore.originDestinationPortId.value || undefined,
            packing: orderStore.packingName.value || undefined,
            packingQuantity: orderStore.packingQuantity.value || undefined,
            pinCode: orderStore.pinCode.value?.trim() || undefined,
            recipient: orderStore.recipient.value || undefined,
            relationType: orderStore.relationType.value,
            remarks: orderStore.remarks.value || undefined,
            requestedTemp1: orderStore.requestedTemp1.value ? Number(Utils.changeCommaToDot(orderStore.requestedTemp1.value)) : undefined,
            requestedTemp2: orderStore.requestedTemp2.value ? Number(Utils.changeCommaToDot(orderStore.requestedTemp2.value)) : undefined,
            securingDeclaration: orderStore.securingDeclaration.value,
            shipownerId: orderStore.shipownerId.value || undefined,
            status: orderStore.status.value,
            trailerRegNo: orderStore.trailerRegNo.value?.trim() || undefined,
            shipperId: orderStore.transportCompanyId.value || undefined,
            VGM: orderStore.vgm.value ? Number(Utils.changeCommaToDot(orderStore.vgm.value)) : undefined,
            voyageNo: orderStore.voyageNo.value?.trim() || undefined,
            wagonRegNo: orderStore.wagonRegNo.value?.trim() || undefined,
            supplierWagonRegNo: orderStore.supplierWagonRegNo.value?.trim() || undefined,
            recipientWagonRegNo: orderStore.recipientWagonRegNo.value?.trim() || undefined,
            weight: orderStore.weight.value ? Number(Utils.changeCommaToDot(orderStore.weight.value)) : null,
            width: orderStore.width.value ? Number(Utils.changeCommaToDot(orderStore.width.value)) : undefined
        };
    }

    private prepareDataToApiForModifyOrder(): NewOrUpdateOrderModel {
        const orderStore = this.context.orderStore as IOrderStore;

        return {
            ...this.prepareDataToApiForNewOrder(),
            storageTime: orderStore.storageTime.value || undefined,
            paymentDocumentNumber: orderStore.paymentDocumentNumber.value || undefined
        };
    }
}

export default withRouter(observer(OrderForm));
